import './aboutUs.css';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/700-italic.css';

const AboutUs = () => {
    return (
        <>
            <div className="about-wrap">

                <div className="eyebrow">About Twigaa</div>
                <h1>Built by someone who's spent real time <em>in the field.</em></h1>
                <p className="lede">Twigaa isn't a generic CRM with a travel skin. It's built by people who've watched safari operators work up close — and decided the industry deserved software that actually understands it.</p>

                <div className="founder">
                    <div>
                        <div className="avatar"><span className="initials">MG</span></div>
                        <div className="avatar-cap">
                            <div className="name">Manjunath Gowda</div>
                            <div className="role">Founder &amp; CEO</div>
                        </div>
                    </div>
                    <div className="story">
                        <p>Before Twigaa, I ran an Indian DMC, putting together safari packages in Africa for Indian travelers, as well as Indian safari packages for the world — which meant real time alongside operators on the ground, watching how the work actually got done. What I saw stuck with me: sharp, hardworking teams running extraordinary logistics — multi-property room blocks, multi-country itineraries, seasonal rate cards with a dozen exceptions each — on Excel and WhatsApp. Not because they didn't know better, but because nothing built for this industry had ever really understood it.</p>
                        <p>I'd spent three years at <strong>Freshworks</strong> watching what good B2B software could do for underserved markets, and I'd already taken two companies from idea to acquisition — <strong>S7</strong> (acquired by Symantec) and <strong>i7 Networks</strong>, whose security technology was demoed to the FBI and Cisco. I knew what good software looked like. I just hadn't found the place it was needed most.</p>
                        <p>Twigaa is that place. I went through <strong>Cornell's AI program</strong> specifically to help build Oxpecker and RateScript — the engine at the center of everything we do — because this problem deserved the same rigor as any hard engineering challenge, just finally pointed at an industry that had waited too long for it.</p>
                        <p>Today, a 67-year-old Kenya DMC runs its entire business on what we built. That's the bar we hold ourselves to with every operator after them.</p>

                        <div className="chips">
                            <span className="chip">S7 → acquired by Symantec</span>
                            <span className="chip">i7 Networks — FBI &amp; Cisco demoed</span>
                            <span className="chip">3 yrs at Freshworks</span>
                            <span className="chip">Founder, Indian DMC — Africa Safaris</span>
                            <span className="chip">Cornell AI Program</span>
                        </div>
                    </div>
                </div>

                <div className="pullquote">
                    <p>"We didn't set out to build another piece of software. We set out to build the thing this industry actually needed — and we're not done."</p>
                    <div className="attr">— Manjunath Gowda, Founder &amp; CEO</div>
                </div>

                <div className="team-head">
                    <div className="eyebrow">The Team</div>
                    <h2>Seven people. Every part of the business, covered.</h2>
                    <p>From the people who talk to operators every day to the people who build the engine underneath — this is who's behind Twigaa.</p>
                </div>

                <div className="team-grid">
                    <div className="tcard">
                        <div className="tavatar"><span>P</span></div>
                        <h3>Pooja</h3>
                        <div className="role">Sales Executive</div>
                        <p>Works directly with operators across Kenya and Rest of East Africa — usually the first person you'll talk to.</p>
                    </div>
                    <div className="tcard">
                        <div className="tavatar"><span>A</span></div>
                        <h3>Anisha</h3>
                        <div className="role">Sales Executive</div>
                        <p>Leads operator outreach across East Africa and Southern Africa, building relationships that turn into real partnerships.</p>
                    </div>
                    <div className="tcard">
                        <div className="tavatar"><span>D</span></div>
                        <h3>Divya</h3>
                        <div className="role">Customer Success</div>
                        <p>Makes sure every operator gets properly onboarded — and stays supported long after go-live.</p>
                    </div>
                    <div className="tcard">
                        <div className="tavatar"><span>AN</span></div>
                        <h3>Arulkumar N</h3>
                        <div className="role">Frontend Engineer</div>
                        <p>Builds the interface every user touches — the part of Twigaa that has to just work, every time.</p>
                    </div>
                    <div className="tcard">
                        <div className="tavatar"><span>S</span></div>
                        <h3>Sayali</h3>
                        <div className="role">Implementation Specialist</div>
                        <p>Turns messy rate sheets into clean, working data — the unglamorous work that makes everything else possible.</p>
                    </div>
                    <div className="tcard">
                        <div className="tavatar"><span>S</span></div>
                        <h3>Shobha</h3>
                        <div className="role">Implementation Specialist</div>
                        <p>Handles contract extraction and customer setup, getting every new operator quoting accurately from day one.</p>
                    </div>
                </div>

                <div className="cta">
                    <h2>Want to see what we've built?</h2>
                    <p>We'd love to show you Twigaa running on your own contracts.</p>
                    <div className="ctas">
                        <a className="btn primary"
                            onClick={() =>
                                window.gtag_report_conversion()
                            }
                            href="https://forms.gle/GsaFJ4kCVUuUEftq5"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                        Book a Demo</a>
                        <a className="btn outline"
                           onClick={() =>
                                window.gtag_report_conversion()
                            }
                            href="https://forms.gle/GsaFJ4kCVUuUEftq5"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                        Get in Touch</a>
                    </div>
                </div>

            </div>
        </>
    )
}

export default AboutUs